var _style, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _rect3, _ellipse, _path6, _g, _path7, _g2, _g3, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Graduation",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#2A94F4;}\n\t.st1{fill:#FFBE55;}\n\t.st2{opacity:0.19;fill:#020202;}\n\t.st3{opacity:0.13;}\n\t.st4{fill:#D3D3D3;}\n\t.st5{fill:#F7F7F7;}\n\t.st6{fill:#F2F2F2;}\n\t.st7{fill:#FCD2B1;}\n\t.st8{fill:#E9D6B8;}\n\t.st9{fill:#B0BFDE;}\n\t.st10{fill:#0B4870;}\n\t.st11{fill:#0E538C;}\n\t.st12{fill:#FFE3CA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1370.5,1080H790.7c-11.4,0-20.6-9.2-20.6-20.6V314.6c0-171.5,139-310.5,310.5-310.5h0  c171.5,0,310.5,139,310.5,310.5v744.8C1391.2,1070.8,1381.9,1080,1370.5,1080z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1096.1,
    y: 114.8,
    transform: "matrix(0.6701 0.7423 -0.7423 0.6701 464.0612 -807.4915)",
    className: "st1",
    width: 88.7,
    height: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1104.5,
    y: 115.7,
    transform: "matrix(0.6701 0.7423 -0.7423 0.6701 466.9258 -798.733)",
    className: "st1",
    width: 54.9,
    height: 20.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M970,97.7c0,0-58.7,43.1-51.7,40.9c0,0,67.8,14.4,70-9.8S977.7,92,970,97.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M970,97.7c0,0-58.7,43.1-51.7,40.9c0,0,67.8,14.4,70-9.8S977.7,92,970,97.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1284.5,155.4c0,0,32.1,90.4,21.8,132.6l-142.3-25.4C1163.9,262.5,1250.2,148.3,1284.5,155.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1284.5,155.4c0,0,32.1,90.4,21.8,132.6l-142.3-25.4C1163.9,262.5,1250.2,148.3,1284.5,155.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 832.2,
    y: 816.1,
    className: "st4",
    width: 474,
    height: 263.9
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 1069.2,
    cy: 816.1,
    rx: 237,
    ry: 61
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1266.1,816.4c0-16.1-85.1-29.2-190.1-29.2c-105,0-190.1,13.1-190.1,29.2s85.1,29.2,190.1,29.2  c1.5,0,3.1,0,4.6,0c0,0,0,0,0,0c0,6.1,32.4,11.1,72.4,11.1c40,0,72.4-5,72.4-11.1c0-3-7.8-5.8-20.5-7.8  C1242.6,832.5,1266.1,824.8,1266.1,816.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M971.3,144.5l-19.1-92.3c0,0,13.2-2.6,17.8,9.2c10.1,25.9,26,57.6,25.9,76.9    C995.7,168.5,971.3,144.5,971.3,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1244.3,176.7L1303,127l18.1,4.4c0,0-41.3,60.3-60.2,70.8C1241.9,212.7,1244.3,176.7,1244.3,176.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1306.3,141.5c0,0-5.2-15.2-2.7-19c2.5-3.8,12.7-17.3,12.7-17.3l2.9-3.2c0,0,5.4,1.2-1.5,10.1     c-6.9,9-1.1,6.4-1.1,6.4l9.5-5.8l12.2-6.2l5-3.4c0,0,12.4,2.9,10.8,9.2c-2.1,8.9-18.7,22.3-18.7,22.3l-26.3,10.5L1306.3,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1333.6,121.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M961.5,66.9c0,0,10.2-12.4,9.2-16.9c-1-4.5-5.8-20.6-5.8-20.6l-1.6-4c0,0-5.5-0.7-2.1,10     c3.4,10.8-1.2,6.4-1.2,6.4l-6.8-8.7c0,0,0.4-4-0.9-3.6c-8.4,2.8-10.7,9.1-11,14.2l-0.2,3.6c-0.1,1.7,0.4,3.4,1.6,4.6l15.1,17.4     L961.5,66.9z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1070.5,204.8 1012.4,162 1004.4,144.5 1009.2,143.7 999,127.3 963.3,137 968.7,166.3 974,165.9    979.5,182.4 987.4,184.8 1035.4,259.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1136.5,785.6l-1.2,18.8l1.1,15.9l5.7,5.1l4.5,2.1l1,2.8l14.8,13.2c4.1,2.6,10.2,4.5,18.1,3.8    c2.7-0.2,0.1-7.7-0.6-8.9c-4.3-6.8-11.2-14.5-11.2-14.5l-10.4-17.4l-11.5-21.6L1136.5,785.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1010,768.5l3,8l0.9,8.7l-2.3,13.3l-7.5,0l-5.3-2l-4,2c0,0-21.3,1-29.1,0.1c-13-1.5-19.8-3.8-22-6.7    c-1.2-1.6,5.2-3.4,7.2-3.4c11.7,0,24.8-5.5,24.8-5.5l11-9.1l2.9-7.2L1010,768.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1154.4,213.8l-94.3-17.7c0,0-80,37.2-71,197.3c0,0.8,117.3,32.6,117.1,2    C1105.5,319,1154.4,213.8,1154.4,213.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1101.7,397.2 1163.9,806.7 1133.5,803.8 1095.5,664.9 1087.4,623.5 1042,459 1036.7,390    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1015.4,770.7 1008.2,627.4 1027.6,551.2 1053,446.3 1045.4,390.8 989.5,385.3 982.9,426.3      965.2,596.3 961.3,637.6 978.9,774.5    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1094.1,179.2c-4.7,20.8-14.3,31.9-13.9,33.4l3.6-2l22.5,3.2l1.5-4.3c0-0.8,3.7,2.5,4,1.1     c2.1-8.6,9.3-26.6,11.2-29.4C1125.3,177.9,1096.9,166.9,1094.1,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1098.4,123.6l-18.4,33.2c-7,12.6-2.2,22.5,8.1,32.6c2.3,2.3,22.1,7.6,29.3-2.6     c7.1-10.2,20.3-36.6,20.3-36.6s1-10.5-18-14.1C1100.6,132.5,1098.4,123.6,1098.4,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1106.9,112.4c-2.6-0.6-7.3-0.9-10.2,2.4c-3.1,3.4-6.6,15.8-3.6,18.5c2.9,2.6,28.8,9.8,32,10.3     c3.2,0.5,8.9,2.2,13.5-0.7c3-1.8-2.1-12.1-7.8-13.3C1116.2,126.5,1116.5,114.6,1106.9,112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1132.8,140.1c0,0-0.8,0.7-2.1,1.8c-8.5,7.5-13.5,18.2-13.6,29.6v0c-0.6,1.6,0.1,3.4,1.6,4.2l0,0l2.4,1.3     c1.4,0.7,3.1,0.4,4.1-0.7c5.5-6.1,21.6-24.9,17-31C1136.8,137.8,1134.1,138.6,1132.8,140.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1117.8,177.9c-1,1.9-0.3,4.2,1.6,5.3l2,1.1c1.9,1,4.3,0.3,5.4-1.5l4.4-8c1.1-1.9,0.3-4.2-1.6-5.3l-2-1.1     c-1.9-1-4.3-0.3-5.4,1.5L1117.8,177.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1086.2,211.5c0,0-63.9,66.5-79.7,155.4c-1.2,7,4.3,13.8,4.3,13.8l12.7-7    C1023.5,373.7,1053.3,276.5,1086.2,211.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1086.9,211.1 1084.9,224.3 1115,210.6 1114.2,207   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1082.7,202.7 1074.3,216.2 1086.7,210.8   "
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1127.2,205.8c0,0,92.4-15.6,145.8-53.1c0,0-9.6,118.2,33.2,135.2c0,0-143.3-8-165.9-21.7  c0,0,19.6,327,33.2,373.8c0,0-93,5.7-120.6,0c-27.6-5.7-95.9-6-105.6-41.7c0,0,23.1-250,40.9-321.8c0,0-68.8-114.2-70-138  c0,0,64.2-15.7,65.4-44.8c0,0,26.7,58.5,83.6,103.7c0,0-6.2,4.2-8,34.3c-0.6,9.6,10.2,15.5,18,9.9L1127.2,205.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M934.3,89.8l-0.9-0.4c-3.3-1.4-4.9-5.3-3.4-8.7l33.4-76.9c1.4-3.3,5.3-4.9,8.7-3.4l0.9,0.4   c3.3,1.4,4.9,5.3,3.4,8.7l-33.4,76.9C941.5,89.7,937.6,91.2,934.3,89.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4302 -0.9027 0.9027 0.4302 548.2567 879.0301)",
    className: "st4",
    cx: 970.4,
    cy: 5.2,
    rx: 2.1,
    ry: 5.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M961.5,66.9c0,0,10.2-12.4,9.2-16.9c-1-4.5-5.8-20.6-5.8-20.6l-1.6-4c0,0-5.5-0.7-2.1,10   c3.4,10.8-0.6,11.1-0.6,11.1l-3,22.9L961.5,66.9z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M952.2,29.6c0,0,8.5,3.2,6.1,9.7c-2.4,6.5-13,13.8-15.8,12.7S947.6,34.4,952.2,29.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduating);
export default __webpack_public_path__ + "static/media/graduating.13ea1efdb012f44baecc13fff328de6a.svg";
export { ForwardRef as ReactComponent };